import { Component, Input, OnChanges, SimpleChanges, ViewChildren, QueryList, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgbdSortableHeaderDirective } from 'src/app/modules/core/directives/ngbdSortableHeader.directive';
import { IReportByAllStatus, IStatusFamily, ISubStateTable } from '../../../interfaces/machine-status';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubstateModalComponent } from '../substate-modal/substate-modal.component';
import { ITableHeaderParams } from '../../../../../../../projects/common/src/app/interfaces/table/table-header-params';
import { ITableDataParams } from '../../../../../../../projects/common/src/app/interfaces/table/table-data-params';
import { TableConfigService } from '../../../../../../../projects/common/src/app/services/table/table-config.service';
import { ITableExtraParams } from '../../../../../../../projects/common/src/app/interfaces/table/table-extra-params';
import { ITableConfig } from '../../../../../../../projects/common/src/app/interfaces/table/table-config';
import { ITableDataOption } from '../../../../../../../projects/common/src/app/interfaces/table/table-data-option';

@Component({
  selector: 'app-substate-table',
  templateUrl: './substate-table.component.html',
  styleUrls: ['./substate-table.component.scss'],
})
export class SubstateTableComponent implements OnChanges, OnDestroy {
  @ViewChildren(NgbdSortableHeaderDirective) private headers: QueryList<NgbdSortableHeaderDirective>;
  @Input() public data: any;

  private reportByAllStatus: IReportByAllStatus[];
  public reportByStatusFamily: IStatusFamily[];

  private subSource: Subscription;
  private subCollectionSize: Subscription;
  public tableConfig: ITableConfig;

  constructor(private modal: NgbModal, private tableConfigService: TableConfigService) {
    this.subCollectionSize = new Subscription();
  }

  /**
   * On component change
   */
  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && changes.data.currentValue) {
      this.reportByStatusFamily = changes.data.currentValue.reportByStatusFamily;
      this.setTableConfig(changes.data.currentValue.reportByStatusFamily);
      this.reportByAllStatus = changes.data.currentValue.reportByAllStatus; // data for detail modal
    }
  }

  /**
   * Function to set table config
   *
   * @param tableData Data to fill table
   */
  private setTableConfig(tableData: any[]): void {
    const subStateData = this.subStateTableMapper(tableData);
    const excludeColumns = ['statusId', 'statusColor', 'durationStatus', 'percentage'];

    const headerParams: ITableHeaderParams = {
      data: subStateData,
      sortables: ['status', 'substate', 'percentSymbol', 'time', 'durationStatus'],
      excludeColumns,
      sortField: [{ field: 'time', order: 'asc', sortBy: 'durationStatus' }],
    };
    const datasetParams: ITableDataParams = {
      tableData: subStateData,
      colorConfig: [{ field: 'status', isColorStatus: true, isBold: true, statusColor: 'statusColor' }],
      replaceConfig: [{ field: 'percentSymbol', replaceText: '[value]%', fieldToReplace: 'percentSymbol', isUnit: false }],
      clickConfig: [{ field: 'substate', hasCursorPointer: true, hasBoldHover: true }],
      excludeColumns,
    };

    const minimalRows = 10;
    const quantityPerPage = tableData.length > 10 ? minimalRows : tableData.length;

    const extraParams: ITableExtraParams = {
      noDataMsg: 'm019',
      disableFooter: false,
      minimalRows: tableData.length > 10 ? minimalRows : tableData.length,
      quantityPerPage,
    };

    const header = this.tableConfigService.setHeaderConfig(headerParams);
    const dataset = this.tableConfigService.setDatasetConfig(datasetParams);

    this.tableConfig = { header, dataset, extraParams };
  }

  /**
   * Function to set table config
   *
   * @param tableData Table data to map
   */
  private subStateTableMapper(statusData: IStatusFamily[]): ISubStateTable[] {
    return statusData.map((status) => {
      return {
        statusId: status.statusId,
        status: status.statusFamilyName.toUpperCase(),
        statusColor: status.statusFamilyColor,
        substate: status.statusName,
        percentSymbol: status.percentage,
        time: status.durationTime,
        durationStatus: status.durationStatus,
        percentage: status.percentage,
      } as ISubStateTable;
    });
  }

  /**
   * Open Modal
   *
   * @param value status
   */
  public openSubstateModal(value: { row: ITableDataOption[]; cell: ITableDataOption }): void {
    const selectedStatus = this.reportByStatusFamily.find(
      (report) => !!value.row.find((row) => row.value.toString() === report.statusId.toString()),
    );
    const modalData = {
      selectedStatus,
      allStatus: this.reportByAllStatus,
    };

    const modalRef = this.modal.open(SubstateModalComponent, {
      centered: true,
      backdrop: 'static',
      windowClass: 'report-machine-status-modal',
    });

    modalRef.componentInstance.modalData = modalData;
  }

  /**
   * On destroy component
   */
  public ngOnDestroy(): void {
    if (this.subSource) {
      this.subSource.unsubscribe();
    }
    if (this.subCollectionSize) {
      this.subCollectionSize.unsubscribe();
    }
  }
}
